var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.className,on:{"click":_vm.wave}},[(_vm.text)?_c('p',{staticClass:"white-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }